/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FileControllerGetFilesDetailsParams,
  FileDetailsResponse,
  UploadFileRequest
} from './sAFcBackend.schemas.js';

import fileControllerGetFilesDetailsMutator from '../response-type.js';
import fileControllerGetFileMutator from '../response-type.js';
import fileControllerUploadFileMutator from '../response-type.js';
import { customFormData } from '../mutators/custom-file-data.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const fileControllerGetFilesDetails = (
    params: FileControllerGetFilesDetailsParams,
 options?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>,signal?: AbortSignal
) => {


      return fileControllerGetFilesDetailsMutator<FileDetailsResponse[]>(
      {url: `/api/file/details`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFileControllerGetFilesDetailsQueryKey = (params?: FileControllerGetFilesDetailsParams,) => {
    return [
    `/api/file/details`, ...(params ? [params] : [])
    ] as const;
    }


export const getFileControllerGetFilesDetailsQueryOptions = <TData = Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError = unknown>(params: FileControllerGetFilesDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetFilesDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>> = ({ signal }) => fileControllerGetFilesDetails(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FileControllerGetFilesDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>>
export type FileControllerGetFilesDetailsQueryError = unknown


export function useFileControllerGetFilesDetails<TData = Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError = unknown>(
 params: FileControllerGetFilesDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fileControllerGetFilesDetails>>,
          TError,
          Awaited<ReturnType<typeof fileControllerGetFilesDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFileControllerGetFilesDetails<TData = Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError = unknown>(
 params: FileControllerGetFilesDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fileControllerGetFilesDetails>>,
          TError,
          Awaited<ReturnType<typeof fileControllerGetFilesDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFileControllerGetFilesDetails<TData = Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError = unknown>(
 params: FileControllerGetFilesDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFileControllerGetFilesDetails<TData = Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError = unknown>(
 params: FileControllerGetFilesDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFilesDetails>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFilesDetailsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFileControllerGetFilesDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const fileControllerGetFile = (
    fileId: string,
 options?: SecondParameter<typeof fileControllerGetFileMutator>,signal?: AbortSignal
) => {


      return fileControllerGetFileMutator<Blob>(
      {url: `/api/file/download/${fileId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getFileControllerGetFileQueryKey = (fileId: string,) => {
    return [
    `/api/file/download/${fileId}`
    ] as const;
    }


export const getFileControllerGetFileQueryOptions = <TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = unknown>(fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFileMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFileControllerGetFileQueryKey(fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fileControllerGetFile>>> = ({ signal }) => fileControllerGetFile(fileId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FileControllerGetFileQueryResult = NonNullable<Awaited<ReturnType<typeof fileControllerGetFile>>>
export type FileControllerGetFileQueryError = unknown


export function useFileControllerGetFile<TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = unknown>(
 fileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fileControllerGetFile>>,
          TError,
          Awaited<ReturnType<typeof fileControllerGetFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fileControllerGetFileMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFileControllerGetFile<TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = unknown>(
 fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fileControllerGetFile>>,
          TError,
          Awaited<ReturnType<typeof fileControllerGetFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fileControllerGetFileMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFileControllerGetFile<TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = unknown>(
 fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFileMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFileControllerGetFile<TData = Awaited<ReturnType<typeof fileControllerGetFile>>, TError = unknown>(
 fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fileControllerGetFile>>, TError, TData>>, request?: SecondParameter<typeof fileControllerGetFileMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFileControllerGetFileQueryOptions(fileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Upload a file
 */
export const fileControllerUploadFile = (
    uploadFileRequest: UploadFileRequest,
 options?: SecondParameter<typeof fileControllerUploadFileMutator>,signal?: AbortSignal
) => {

      const formData = customFormData(uploadFileRequest)
      return fileControllerUploadFileMutator<FileDetailsResponse>(
      {url: `/api/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getFileControllerUploadFileMutationKey = () => ['fileControllerUploadFile'] as const;

export const getFileControllerUploadFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,FileControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof fileControllerUploadFileMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,FileControllerUploadFileMutationVariables, TContext> => {

const mutationKey = getFileControllerUploadFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileControllerUploadFile>>, FileControllerUploadFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  fileControllerUploadFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FileControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof fileControllerUploadFile>>>
    export type FileControllerUploadFileMutationBody = UploadFileRequest
    export type FileControllerUploadFileMutationError = unknown
    export type FileControllerUploadFileMutationVariables = {data: UploadFileRequest}

    export const useFileControllerUploadFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileControllerUploadFile>>, TError,FileControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof fileControllerUploadFileMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof fileControllerUploadFile>>,
        TError,
        FileControllerUploadFileMutationVariables,
        TContext
      > => {
      return useMutation(getFileControllerUploadFileMutationOptions(options), queryClient);
    }
